import React from "react";
import Image from "next/image";
import DemoButton from "../Demo/DemoButton";
import CustomButton from "../Buttons/CustomButton";
import Link from "next/link";
import slider1 from "@/Helper/images/slider/retail/slider1.png";
const Retail = () => {
  return (
    <div className="industry_container">
      <div className="industry_left_content">
        <p className="heading">Boost retail processes in an intelligent way</p>
        <p className="subheading">
          AI technology helps to keep an update on the unique visitor count,
          demographics analytics, retail analytics & enabling retailers to keep
          track of the overall footfall.
        </p>

        <div className="btn_container">
          <DemoButton PrimaryColorBtn />

          <Link href={"/retail"}>
            <CustomButton Text={"View More"}></CustomButton>
          </Link>
        </div>
      </div>
      <div className="industry_right_content">
        <div className="slider_bg normal_bg">
          <Image
            src={slider1}
            alt="Digital signage software driving steadfast results"
            width={459}
            height={253}
            className="productbanner_imageslider"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
};

export default Retail;
